module.exports = __webpack_public_path__ + "media/images/writer/home/home-03@2x-c59840e8321cb82fc72df6d22667b433.png";